// Crowned owl logo + CaprioKnows wordmark.
export function BrandLogo({ size = "lg", showTagline = true, onClick }) {
    const owl = {
        sm: "h-9 w-9",
        md: "h-14 w-14",
        lg: "h-28 w-28 sm:h-32 sm:w-32",
    }[size];
    const word = {
        sm: "text-xl",
        md: "text-3xl",
        lg: "text-5xl sm:text-6xl lg:text-7xl",
    }[size];

    const Wrapper = onClick ? "button" : "div";

    return (
        <Wrapper
            onClick={onClick}
            data-testid="brand-logo"
            aria-label="CaprioKnows home"
            className={`flex flex-col items-center gap-3 bg-transparent border-0 ${
                onClick ? "cursor-pointer" : ""
            }`}
        >
            <img
                src="/owl-logo.png"
                alt="CaprioKnows crowned owl logo"
                className={`${owl} object-contain ${
                    size === "lg" ? "owl-float" : ""
                }`}
                draggable="false"
            />
            <div className="flex flex-col items-center">
                <div
                    className={`font-serif-brand font-bold leading-none ${word}`}
                >
                    <span style={{ color: "var(--ck-charcoal)" }}>Caprio</span>
                    <span style={{ color: "var(--ck-royal)" }}>Knows</span>
                    <sup
                        className="font-sans text-[0.4em] align-super ml-0.5"
                        style={{ color: "var(--ck-gold)" }}
                    >
                        ™
                    </sup>
                </div>
                {showTagline && (
                    <p
                        className="tracking-label text-[10px] sm:text-xs mt-2 font-medium"
                        style={{ color: "var(--ck-charcoal)", opacity: 0.7 }}
                    >
                        Curiosity Goes Further
                    </p>
                )}
            </div>
        </Wrapper>
    );
}
